import { defaultConfig } from './default-plugin-config';

export const config = {
  default: defaultConfig,
};
